import { PrivateRoutes } from 'infrastructure/shared/components'
import { Route, Routes } from 'react-router-dom'
import TokenContainer from './TokenContainer/TokenContainer'

const TokenRoutes = () => {
  return (
    <Routes>
      <Route element={<PrivateRoutes />}>
        <Route path=':tokenUuid' element={<TokenContainer />} />
      </Route>
    </Routes>
  )
}

export default TokenRoutes
